import * as React from 'react';
import * as styles from './index.css';
import { ICoworking } from '../../types/offer';

export const Coworking: React.SFC<ICoworking> = ({ name, url }) => {
  if (!name) {
    return null;
  }
  const coworkingName = `Коворкинг «${name}»`;

  if (url) {
    return <a href={url} className={styles['building-link']}>
      {coworkingName}
    </a>;
  }

  return <div>{coworkingName}</div>;
};

Coworking.displayName = 'Coworking';
